import type { SubcategoryMaterial } from '@/entities/category';

export function isSafeMaterialUrl(url: string): boolean {
  const probe = [...url].filter((ch) => ch.charCodeAt(0) > 0x20).join('');
  if (/^[a-z][a-z0-9+.-]*:/i.test(probe)) return /^https?:/i.test(probe);
  return true;
}

export function parseMaterials(text: string): SubcategoryMaterial[] {
  return text
    .split('\n')
    .map((line): SubcategoryMaterial | null => {
      const [title, url] = line.split('|').map((str) => str.trim());
      if (!title) return null;
      return { title, url: url && isSafeMaterialUrl(url) ? url : undefined };
    })
    .filter((m): m is SubcategoryMaterial => m != null);
}

export function formatMaterials(materials: SubcategoryMaterial[] | null | undefined): string {
  if (!materials?.length) return '';
  return materials.map((m) => (m.url ? `${m.title} | ${m.url}` : m.title)).join('\n');
}
